export default __webpack_public_path__ + "static/media/twitter.db226d55.svg";